import "./App.css";
import Routing from "./App/navigation/routes";

function App() {
  return <Routing />;
}

export default App;
